import { render } from "./AccountUpdate.vue?vue&type=template&id=8db16390"
import script from "./AccountUpdate.vue?vue&type=script&lang=js"
export * from "./AccountUpdate.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__